import React from 'react';
import './RedirectingAnimation.scss';

export const RedirectingAnimation: React.FC = () => {
    return (
        <div className="redirecting-animation">
            <span className="redirecting-text">Redirecting</span>
            <span className="dots">
                <span className="dot dot-1">.</span>
                <span className="dot dot-2">.</span>
                <span className="dot dot-3">.</span>
            </span>
        </div>
    );
};